import { Box, Grid2 as Grid } from "@mui/material";
import { ModalForm, NoteItem } from "../../../types";
import { TextField } from "../../common";
import { useValidateForm } from "../../../hooks";
import { z } from "zod";

type FormData = Pick<NoteItem, "id" | "orgId" | "accountId" | "note">;

type NoteFormProps = ModalForm<NoteItem, FormData>;

export const EditNotesForm = ({
  id,
  defaultValues,
  handleEdit,
}: NoteFormProps) => {
  const { register, handleSubmit, errors } = useValidateForm(
    z.object({
      note: z.string().min(1, "This field is required"),
    }),
  );

  const handleEditWrapper = (data: { note: string }) => {
    handleEdit({
      id: defaultValues ? defaultValues.id : 0,
      orgId: defaultValues ? defaultValues.orgId : 0,
      accountId: defaultValues ? defaultValues.accountId : 0,
      note: data.note,
    });
  };

  return (
    <Box
      onSubmit={handleSubmit(handleEditWrapper)}
      component={"form"}
      id={id}
      noValidate
      sx={{
        height: "100%",
      }}
    >
      <Grid
        container
        size={12}
        direction={"column"}
        gap={3}
        sx={{
          borderRadius: "10px",
          p: 3,
          mb: 2,
          width: "100%",
        }}
      >
        <Grid size={12}>
          <TextField
            label="Note"
            name="note"
            multiline
            rows={4}
            required
            error={errors["note"]}
            register={register}
            defaultValue={defaultValues?.note || ""}
            sx={{
              "& .MuiInputBase-input": {
                padding: "0rem",
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
